// extracted by mini-css-extract-plugin
export default {"bonuses":"BonusCardsGrid__bonuses--slots-BUmwB","component":"BonusCardsGrid__component--slots-IwXGq","item":"BonusCardsGrid__item--slots-hloc0"};